export default __webpack_public_path__ + "media/images/portrait-bd6b67f903ccd13f8f66fed89162b249.jpg";